import i18n from '@/locales/i18n';
import { message } from '@koi-design/uxd-ui';
import store from '@/store';
import { notifyAccountStatusChange } from '@/libs/accountSync';

const SKIP_ROUTE_RESTORE_KEY = 'sbt_skip_route_restore';
const AUTH_EXCLUDE_PATHS = [
  '/login',
  '/introduce',
  '/auth/callback',
  '/documentPublic',
  '/agreement',
  '/privacyPolicy',
  '/baiyuAgreement',
  '/baiyuPrivacyPolicy',
  '/myConsult',
  '/botWeb',
  // Public Composer share pages must stay reachable without a login so a
  // shared link never bounces to /login on a 401.
  '/composer/share',
  '/composer/file-share'
];

let routerInstance = null;
let isHandlingSessionExpired = false;

export function setAuthRouter(router) {
  routerInstance = router;
}

export function isInIframe() {
  return window.self !== window.top;
}

export function shouldSkipIframeRouteRestore() {
  try {
    return sessionStorage.getItem(SKIP_ROUTE_RESTORE_KEY) === '1';
  } catch {
    return false;
  }
}

export function clearSkipIframeRouteRestore() {
  try {
    sessionStorage.removeItem(SKIP_ROUTE_RESTORE_KEY);
  } catch {
    // ignore
  }
}

function markSkipIframeRouteRestore() {
  try {
    sessionStorage.setItem(SKIP_ROUTE_RESTORE_KEY, '1');
  } catch {
    // ignore
  }
}

export function hasAuthToken() {
  return Boolean(localStorage.getItem('sbtToken'));
}

export function isAuthExcludedPath(path) {
  return AUTH_EXCLUDE_PATHS.some(
    item => path === item || path.startsWith(`${item}/`)
  );
}

function clearAuthStorage() {
  localStorage.removeItem('sbtToken');
  localStorage.removeItem('sessionId');
  localStorage.removeItem('auth_provider');
  store.commit('setUserInfo', {
    token: '',
    refresh_token: ''
  });
}

function notifyParentLoginRoute() {
  if (!isInIframe() || !window.parent) {
    return;
  }
  window.parent.postMessage(
    {
      type: 'ROUTE_CHANGE',
      payload: {
        fullPath: '/login'
      }
    },
    '*'
  );
}

/**
 * Handle token/session expiry: clear auth, go to login, block parent RESTORE.
 */
export function handleSessionExpired(response) {
  if (isHandlingSessionExpired) {
    return;
  }

  const currentPath = routerInstance?.currentRoute?.value?.path || window.location.pathname;
  if (isAuthExcludedPath(currentPath) && !hasAuthToken()) {
    return;
  }

  isHandlingSessionExpired = true;
  markSkipIframeRouteRestore();
  notifyAccountStatusChange('session-expired');
  clearAuthStorage();

  const errorMessage =
    response?.data?.message ||
    i18n.global.t('config.requestConfig.38c9a6a47f07a804aaca63409895c3ac');
  message.error(errorMessage, 5);

  const goLogin = () => {
    notifyParentLoginRoute();
    if (routerInstance) {
      routerInstance
        .replace('/login')
        .catch(() => {
          window.location.assign(`${window.location.origin}/login`);
        })
        .finally(() => {
          isHandlingSessionExpired = false;
        });
      return;
    }
    window.location.assign(`${window.location.origin}/login`);
    isHandlingSessionExpired = false;
  };

  goLogin();
}
